<!-- Mesma lista nas duas entradas: reticências (p-menu, colado ao botão) e clique direito
     (p-contextMenu, no ponto do clique). -->
<p-menu #menu [model]="items()" [popup]="true" appendTo="body" styleClass="deal-actions-menu" />
<p-contextMenu #contextMenu [model]="items()" appendTo="body" styleClass="deal-actions-menu" />
